import { lazy } from 'react';
import { Toast } from '../../../core/components/atoms/Toast';

const FreemiumRegisterPage = lazy(() => import('../pages/Register'));

export const FreemiumRoutes = [
  {
    path: 'freemium/cadastro',
    element: (
      <>
        <Toast />
        <FreemiumRegisterPage />
      </>
    ),
  },
];
